import React, { useState } from "react";
import { Box } from "@mui/material";
import EmailDetailsHeader from "./EmailDetailsHeader";
import EmailContentCard from "./EmailContentCard";
import _ from "lodash";
import { useSelector } from "react-redux";
import { isObjectEmpty } from "_helpers";
import LoadingSpinner from "components/v3/views/Channels/Utilities/LoadingSpinner";
import GeneratedResponse from "./GeneratedResponse";
import ReplyBox from "./ReplyBox";

export default function EmailDetailsContainer({
  conversation,
  messageId,
  msgSource,
  author,
  currentUser,
  companyReplied,
  markAsDone,
  link,
}) {
  const [replyText, setReplyText] = useState("");

  const emailConversationData = useSelector(
    (state) => state.fullEmailConversation.emailConversationData,
  );
  const loadingEmailConversation = useSelector(
    (state) => state.fullEmailConversation.loadingEmailConversation,
  );
  const emailConversation =
    _.get(emailConversationData, "emailConversation") || [];
  const emailSubject = isObjectEmpty(emailConversation)
    ? ""
    : Object.entries(emailConversation)[0][1].emailSubject;
  const msgCount = emailConversation?.length || 0;
  const lastConversation = emailConversation[msgCount - 1];
  const lastReplyDate = _.get(lastConversation, "createdDate");

  if (loadingEmailConversation) {
    return (
      <Box
        sx={{
          height: "400px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LoadingSpinner />
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1 }}>
      <Box sx={styles.wrapper}>
        <EmailDetailsHeader
          conversation={conversation}
          msgCount={msgCount}
          lastReplyDate={lastReplyDate}
          emailSubject={emailSubject}
        />
        <Box sx={{ padding: "0px 24px" }}>
          {emailConversation?.map((message) => (
            <EmailContentCard
              key={message.id}
              message={message}
              msgSource={msgSource}
            />
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          padding: "15px",
          borderTop: "1px solid rgb(241, 237, 230)",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "rgba(18, 38, 27, 0.05) 0px 1px 3px",
          mt: 2,
        }}
      >
        {author && (
          <Box
            sx={{
              color: "#12261b",
              fontFamily: "FustatExtraBold",
              fontSize: "14px",
              mb: "12px",
            }}
          >
            Reply to {author}
          </Box>
        )}
        <GeneratedResponse
          draft={conversation?.draft}
          messageId={messageId}
          onUseSuggested={setReplyText}
        />
        <ReplyBox
          link={link}
          conversation={conversation}
          currentUser={currentUser}
          companyReplied={companyReplied}
          markAsDone={markAsDone}
          openedMessageId={messageId}
          replyText={replyText}
          onReplyTextChange={setReplyText}
          isEmail={true}
        />
      </Box>
    </Box>
  );
}

const styles = {
  wrapper: {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "rgba(18, 38, 27, 0.05) 0px 1px 3px",
  },
};
